import { Button, Card, Col, Row, Typography } from 'antd';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import EducationPageChrome from '@/pages/education/components/EducationPageChrome';

const { Paragraph } = Typography;

export default function FeesHubPage() {
  const { t } = useTranslation('education');
  const navigate = useNavigate();

  const cards = [
    { path: '/education/fees/collection', title: t('feeCollection'), desc: t('feeCollectionIntro') },
    { path: '/education/fees/outstanding', title: t('feeOutstanding'), desc: t('feeOutstandingIntro') },
    { path: '/education/fees/family-statement', title: t('feeFamilyStatement'), desc: t('feeFamilyStatementIntro') },
    { path: '/education/fees/promises', title: t('feePromises'), desc: t('feePromisesIntro') },
    { path: '/education/fees/disputes', title: t('feeDisputes'), desc: t('feeDisputesIntro') },
    { path: '/education/fees/heads', title: t('feeHeads'), desc: t('feeHeadsIntro') },
    { path: '/education/fees/structures', title: t('feeStructures'), desc: t('feeStructuresIntro') },
    { path: '/education/fees/demands', title: t('feeDemands'), desc: t('feeDemandsIntro') },
    { path: '/education/fees/concessions', title: t('feeConcessions'), desc: t('feeConcessionsIntro') },
  ];

  return (
    <EducationPageChrome title={t('fees')} description={t('feesIntro')}>
      <Row gutter={[16, 16]}>
        {cards.map((card) => (
          <Col xs={24} md={12} key={card.path}>
            <Card size="small" title={card.title}>
              <Paragraph type="secondary">{card.desc}</Paragraph>
              <Button type="primary" onClick={() => navigate(card.path)}>
                {t('open')}
              </Button>
            </Card>
          </Col>
        ))}
      </Row>
    </EducationPageChrome>
  );
}
